import React, { useEffect } from 'react'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import SubPageHeader from '../../components/SubPageHeader'
import ContentArea from '../../components/ContentArea'
import { setSessionItem } from '../../storeManager'
import { Link as HeadLink, Title } from 'react-head'
import PrivacyPolicyUS from '../../components/privacy-policy/PrivacyPolicyUS'

const PolicyPage = () => {
  useEffect(() => {
    setSessionItem('bannerShown', true)
  })

  return (
    <DefaultLayout>
      <Title>Privacy policy - Lifesum</Title>
      <HeadLink rel="canonical" href="https://lifesum.com/policy/" />
      <HeadLink
        rel="alternate"
        href={`https://lifesum.com/policy-de/`}
        // @ts-ignore
        hreflang="de"
      />
      <SubPageHeader heading="Privacy Policy" stickyHeader={false} />
      <ContentArea>
        <div className="s-text">
          <PrivacyPolicyUS mobile={false} />
        </div>
      </ContentArea>
      <Footer />
    </DefaultLayout>
  )
}

export default PolicyPage
